import { generate } from 'astring'

import { transformEsm } from './ast/transformEsm'
import { transformJsx } from './ast/transformJsx'
import { transformLoopGuard } from './ast/transformLoopGuard'
import { t } from './ast/utils'
import { extractClassNames } from './extract/extractClassNames'
import { extractGlobalVariables } from './extract/extractGlobalVariables'
import { extractImportModules } from './extract/extractImportModules'
import { parse } from './parse'

import type { Identifier, Literal, Options, Program } from 'acorn'

export type { Identifier } from 'acorn'

export interface TransformOptions extends Partial<Options> {
  classNamePrefix?: string
  extractClassNames?: boolean
  extractGlobalVariables?: boolean
  extractImportModules?: boolean
  jsx?: boolean
  loopGuard?: boolean
  module?: boolean
}

export interface TransformResult {
  ast: Program
  classNames?: string[]
  code: string
  globalVariables?: Identifier[]
  importModules?: Literal[]
}

export function transform(
  code = '',
  options: TransformOptions = {}
): TransformResult {
  let ast = parse(code, options)

  let classNames: string[] | undefined
  if (options.extractClassNames) classNames = extractClassNames(ast, options)

  let importModules: Literal[] | undefined
  if (options.extractImportModules)
    importModules = extractImportModules(ast, options)

  let globalVariables: Identifier[] | undefined
  if (options.extractGlobalVariables)
    globalVariables = extractGlobalVariables(ast, options)

  if (options.jsx) ast = transformJsx(ast)
  if (options.module) ast = transformEsm(ast)
  if (options.loopGuard) ast = transformLoopGuard(ast)

  return {
    ast,
    classNames,
    code: generate(ast),
    globalVariables,
    importModules
  }
}

export const TransformFailedResult: TransformResult = {
  ast: t.program([]),
  code: '/** code transform failed **/'
}
